import "~/scss/_base.scss";

import { initFooter } from "~/js/components/footer/footer";
import { initNav } from "~/js/components/nav/nav";


document.addEventListener('DOMContentLoaded', () => {
  let bodyEl:HTMLElement|null = document.querySelector('body');;

  bodyEl?.classList.remove('page-loading');
  
  initNav();
  initFooter();
})